import { toConsumableArray as _toConsumableArray, objectWithoutProperties as _objectWithoutProperties } from '../_virtual/_rollupPluginBabelHelpers.js';
import fastMemoize from 'fast-memoize';
import { border } from './border.esm.js';
export { border } from './border.esm.js';
import { color } from './color.esm.js';
export { color } from './color.esm.js';
import { emSpace } from './em-space.esm.js';
export { emSpace } from './em-space.esm.js';
import { flexbox } from './flexbox.esm.js';
export { flexbox } from './flexbox.esm.js';
import { grid } from './grid.esm.js';
export { grid } from './grid.esm.js';
import { layout } from './layout.esm.js';
export { layout } from './layout.esm.js';
import { position } from './position.esm.js';
export { position } from './position.esm.js';
import { shadow } from './shadow.esm.js';
export { shadow } from './shadow.esm.js';
import { space } from './space.esm.js';
export { space } from './space.esm.js';
import { stylable } from './stylable.esm.js';
export { stylable } from './stylable.esm.js';
import { system } from './system-core.esm.js';
import { typography } from './typography.esm.js';
export { typography } from './typography.esm.js';

var isSVGElement = function isSVGElement(tag) {
  return tag === 'svg' || tag === 'line' || tag === 'circle';
};
var systemProps = fastMemoize(function (isSvg) {
  return [].concat(_toConsumableArray(space.propNames), _toConsumableArray(emSpace.propNames), _toConsumableArray(color.propNames), _toConsumableArray(isSvg ?
  // we want to allow height and width props to propagate to element attribute
  layout.propNames.filter(function (i) {
    return i !== 'height' && i !== 'width';
  }) : layout.propNames), _toConsumableArray(position.propNames), _toConsumableArray(flexbox.propNames), _toConsumableArray(typography.propNames), _toConsumableArray(border.propNames), _toConsumableArray(shadow.propNames), _toConsumableArray(grid.propNames), _toConsumableArray(stylable.propNames));
});
var rest = _objectWithoutProperties(layout, ["width", "height"]);
var resolveLayout = function resolveLayout(tag) {
  return (
    // For svg tags we remove styled-system width and height css func because
    // width and height are invalid in a svg element css class
    isSVGElement(tag) ? system(rest) : layout
  );
};

export { isSVGElement, resolveLayout, systemProps };
//# sourceMappingURL=system-props.esm.js.map
